import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
// import moment from "moment";
import Cookies from "js-cookie";
import { Narendra_Modi_Election_API_URL } from "../Process";

export const useMemberDataPagination = (rowsPerPage, filterData, Village, Locality, IsMerged) =>
  useInfiniteQuery({
    queryKey: ["MemberData", rowsPerPage, filterData, Village, Locality, IsMerged],
    queryFn: async ({ pageParam = null }) => {
      const temptItems = {
        PartNameEnglish: Village,
        LocalityEnglish: Locality,
        IsAssignFamily: "false",
        IsActive: "true",
        IsDelete: "false",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.VoterID : undefined;
    },
  });

// export const useMemberListDataPagination = (rowsPerPage, filterData) =>
//   useInfiniteQuery({
//     queryKey: ["MemberListData", rowsPerPage, filterData],
//     queryFn: async ({ pageParam = null }) => {
//       const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//       const outsideValue = outside?.trim()?.toLowerCase() === "true" ? true : false;
//       const handicapValue = handicap?.trim()?.toLowerCase() === "true" ? true : false;

//       const temptItems = {
//         Name: name || "",
//         MobileNo: mobileNo || "",
//         Gender: gender || "",
//         IDCardNo: idCardNo || "",
//         OutSide: outsideValue,
//         Handicap: handicapValue,
//         Address: locality || "",
//         VillageName: village || "",
//         IsActive: "true",
//         IsDelete: "false",
//         PerPage: rowsPerPage,
//         UniqueID: pageParam,
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberListData`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.statusText}`);
//       }

//       const data = await response.json();
//       return data;
//     },
//     initialPageParam: null,
//     getNextPageParam: (lastPage) => {
//       return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.FamilyHeadMasterID : undefined;
//     },
//   });
// export const useMemberListDataPagination = (rowsPerPage, filterData) =>
//   useInfiniteQuery({
//     queryKey: ["MemberListData", rowsPerPage, filterData],
//     queryFn: async ({ pageParam = null }) => {
//       const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village } = filterData || {};

//       const outsideValue = outside?.trim()?.toLowerCase() === "true" ? true : false;
//       const handicapValue = handicap?.trim()?.toLowerCase() === "true" ? true : false;

//       const temptItems = {
//         Name: name || "",
//         MobileNo: mobileNo || "",
//         Gender: gender || "",
//         IDCardNo: idCardNo || "",
//         OutSide: outsideValue,
//         Handicap: handicapValue,
//         Address: locality || "",
//         VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
//         IsActive: "true",
//         IsDelete: "false",
//         PerPage: rowsPerPage,
//         UniqueID: pageParam,
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberListData_V4`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.statusText}`);
//       }

//       const data = await response.json();
//       return data;
//     },
//     initialPageParam: null,
//     getNextPageParam: (lastPage) => {
//       return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.FamilyHeadMasterID : undefined;
//     },
//   });

export const useMemberListDataPagination = (rowsPerPage, filterData, isAssignFamily = true) =>
  useInfiniteQuery({
    queryKey: ["MemberListData", rowsPerPage, filterData, isAssignFamily],
    queryFn: async ({ pageParam = null }) => {
      const { name, mobileNo, gender, idCardNo, outside, handicap, locality, village, VidhanSabha } = filterData || {};

      const outsideValue = outside?.trim()?.toLowerCase() === "true";
      const handicapValue = handicap?.trim()?.toLowerCase() === "true";

      const temptItems = {
        Name: name || "",
        MobileNo: mobileNo || "",
        Gender: gender || "",
        IDCardNo: idCardNo || "",
        OutSide: outsideValue,
        Handicap: handicapValue,
        Address: locality || "",
        VillageName: village || Cookies.get("Narendra_Modi_Village_ID") || "",
        IsActive: "true",
        IsDelete: "false",
        IsAssignFamily: isAssignFamily,
        Vidhansabha: VidhanSabha || "",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberListData_V4`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      return await response.json();
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.HasNextPage) return undefined;

      const items = lastPage?.data || [];
      if (!items.length) return undefined;

      const lastItem = items[items.length - 1];

      // Cursor field depends on the tab:
      // - "With Family" (isAssignFamily true) → FamilyHeadMasterID.
      // - "Without Family" (isAssignFamily false) → these records carry
      //   no FamilyHeadMasterID/ContactDetailID at all (both null), so
      //   VoterID is the only populated identifier to page on.
      const candidate = isAssignFamily ? lastItem?.FamilyHeadMasterID : lastItem?.VoterID;

      // Guard: empty string / null / undefined stops pagination cleanly
      // instead of looping back to the same page.
      if (candidate === null || candidate === undefined || candidate === "") {
        return undefined;
      }
      return candidate;
    },
  });

// export const useYojnaVoterMemberListDataPagination = (rowsPerPage, filterData) =>
//   useInfiniteQuery({
//     queryKey: ["YojnaVoterMemberListData", rowsPerPage, filterData],
//     queryFn: async ({ pageParam = null }) => {
//       const { name, village } = filterData || {};

//       const temptItems = {
//         "VoterID":"",
//         "PartNameEnglish": village || "",
//         "LocalityEnglish": "",
//         "Name": name || "",
//         "BoothID": "",
//         "MobileNo": "",
//         "SLNo": "",
//         "IDCardNo": "",
//         "Gender": "",
//         "HouseNo": "",
//         IsActive: "true",
//         IsDelete: "false",
//         PerPage: rowsPerPage,
//         UniqueID: pageParam,
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getVoterYojnaDetail`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.statusText}`);
//       }

//       const data = await response.json();
//       return data;
//     },
//     initialPageParam: null,
//     getNextPageParam: (lastPage) => {
//       return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.LatestGramYojnaMemberID : undefined;
//     },
//   });
export const useYojnaVoterMemberListDataPagination = (rowsPerPage, filterData) =>
  useInfiniteQuery({
    queryKey: ["YojnaVoterMemberListData", rowsPerPage, filterData],
    queryFn: async ({ pageParam = null }) => {
      const { name, village } = filterData || {};

      const temptItems = {
        VoterID: "",
        PartNameEnglish: village || Cookies.get("Narendra_Modi_Village_ID") || "",
        LocalityEnglish: "",
        Name: name || "",
        BoothID: "",
        MobileNo: "",
        SLNo: "",
        IDCardNo: "",
        Gender: "",
        HouseNo: "",
        IsActive: "true",
        IsDelete: "false",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVoterYojnaDetail_V4`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.LatestGramYojnaMemberID : undefined;
    },
  });

// export const useVillage = (enabled, selectedFamilyOption) => {
//   return useQuery({
//     queryKey: ["VillageData", selectedFamilyOption],
//     queryFn: () => fetchVillage(selectedFamilyOption),
//     // staleTime: 5 * 60 * 1000,
//     retry: 1,
//     enabled,
//   });
// };

// export const useYojnaBeneficialMemberDataPagination = (enabled, rowsPerPage, GramYojnaID, VillageName) =>
//   useInfiniteQuery({
//     queryKey: ["BeneficialMemberListData", rowsPerPage],
//     queryFn: async ({ pageParam = null }) => {

//       const temptItems = {
//         "VillageNameEnglish": VillageName || "",
//         "GramYojnaID": GramYojnaID || "",
//         "GramYojnaName": "",
//         "Name": "",
//         "BoothID": "",
//         "MobileNo": "",
//         "SLNo": "",
//         "IDCardNo": "",
//         "Gender": "",
//         "HouseNo": "",
//         IsActive: "true",
//         IsDelete: "false",
//         PerPage: rowsPerPage,
//         UniqueID: pageParam
//       };

//       const response = await fetch(`${Narendra_Modi_Election_API_URL}getBeneficialMemberData`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(temptItems),
//       });

//       if (!response.ok) {
//         throw new Error(`Network response was not ok: ${response.statusText}`);
//       }

//       const data = await response.json();
//       return data;
//     },
//     initialPageParam: null,
//     getNextPageParam: (lastPage) => {
//       return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.VoterID : undefined;
//     },
//     enabled
//   });
// In FetchAPI.js
export const useYojnaBeneficialMemberDataPagination = (enabled, rowsPerPage, GramYojnaID, VillageName, searchName = "", searchMobile = "", Vidhansabha) =>
  useInfiniteQuery({
    queryKey: ["BeneficialMemberListData", rowsPerPage, GramYojnaID, VillageName, searchName, searchMobile],
    queryFn: async ({ pageParam = null }) => {
      const payload = {
        VillageNameEnglish: VillageName || "",
        GramYojnaID: GramYojnaID || "",
        Vidhansabha: Vidhansabha || "",
        Name: searchName,
        MobileNo: searchMobile,
        PerPage: rowsPerPage,
        UniqueID: pageParam,
        IsActive: "true",
        IsDelete: "false",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getBeneficialMemberData`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network error");
      return await response.json();
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => (lastPage?.HasNextPage ? lastPage?.data?.[lastPage.data.length - 1]?.VoterID : undefined),
    enabled,
  });

export const useGrantDetailsDataPagination = (enabled, rowsPerPage, VillageID, GrantYojnaName, searchName = "", searchMobile = "") =>
  useInfiniteQuery({
    queryKey: ["GrantDetailsListData", rowsPerPage, GrantYojnaName, VillageID, searchName, searchMobile],
    queryFn: async ({ pageParam = null }) => {
      const payload = {
        GrantYojnaName: GrantYojnaName || "",
        VillageID: VillageID || "",
        YojnaName: searchName || "",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
        IsActive: "true",
        IsDelete: "false",
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageData`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network error");
      return await response.json();
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => (lastPage?.HasNextPage ? lastPage?.data?.[lastPage.data.length - 1]?.GrantDetailID : undefined),
    enabled,
  });

export const useMandaliDetailDataPagination = (rowsPerPage, bhajanMandaliName, villageID, bhajanMandaliTypeID) =>
  useInfiniteQuery({
    // queryKey: ["BhajanMandaliDetailData", rowsPerPage],
    queryKey: ["BhajanMandaliDetailData", bhajanMandaliName],
    queryFn: async ({ pageParam = null }) => {
      const temptItems = {
        BhajanMandaliID: "",
        BhajanMandaliTypeID: bhajanMandaliTypeID || "",
        BhajanMandaliType: "",
        BhajanMandaliName: bhajanMandaliName || "",
        VillageID: villageID || "",
        IsActive: "true",
        IsDelete: "false",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
      };

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      return lastPage?.HasNextPage ? lastPage?.data?.[lastPage?.data?.length - 1]?.BhajanMandaliID : undefined;
    },
  });
export const useVillage = (enabled, selectedFamilyOption, coreType = null) => {
  let IsAssignFamily = null;
  console.log("seledslfjsdkfasdf", selectedFamilyOption);
  if (selectedFamilyOption && coreType === "Family") {
    const option = selectedFamilyOption.toLowerCase();
    if (option === "all") IsAssignFamily = null;
    else if (option === "notfamily") IsAssignFamily = false;
    else if (option === "properfamily") IsAssignFamily = true;
  }

  return useQuery({
    queryKey: ["VillageData", selectedFamilyOption, coreType],
    queryFn: () => fetchVillage(IsAssignFamily, coreType),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useVillageFilter = (enabled, selectedFamilyOption, coreType = null, selectedVidhanSabha) => {
  let IsAssignFamily = null;
  console.log("seledslfjsdkfasdf", selectedFamilyOption);
  if (selectedFamilyOption && coreType === "Family") {
    const option = selectedFamilyOption.toLowerCase();
    if (option === "all") IsAssignFamily = null;
    else if (option === "notfamily") IsAssignFamily = false;
    else if (option === "properfamily") IsAssignFamily = true;
  }

  return useQuery({
    queryKey: ["VillageData-Filter", selectedFamilyOption, coreType],
    queryFn: () => fetchVillageMemberListFilter(IsAssignFamily, coreType, selectedVidhanSabha),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useYojanaVillage = (enabled) => {
  return useQuery({
    queryKey: ["YojanaVillageData"],
    queryFn: () => fetchYojanaVillage(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useLocality = (enabled, selectedVillage, selectedFamilyOption, selectedVidhanSabha) => {
  let IsAssignFamily = null;
  if (selectedFamilyOption) {
    const option = selectedFamilyOption.toLowerCase();
    if (option === "all") IsAssignFamily = null;
    else if (option === "notfamily") IsAssignFamily = false;
    else if (option === "properfamily") IsAssignFamily = true;
  }
  return useQuery({
    queryKey: ["LocalityData", selectedVillage, selectedFamilyOption],
    queryFn: () => fetchLocality(selectedVillage, IsAssignFamily, selectedVidhanSabha),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useMember = (enabled, Village, Locality, IsMerged, coreType = null) => {
  return useQuery({
    queryKey: ["Member-Data", Village, Locality, IsMerged],
    queryFn: () => fetchMemberData(Village, Locality, coreType),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

// Same shape as useMemberListDataPagination — just points to your member endpoint
export const useMemberWithPagination = (enabled, Village, Locality, rowsPerPage, searchText, IsMerged, coreType = null) => {
  return useInfiniteQuery({
    queryKey: ["Member-Data", Village, Locality, IsMerged, rowsPerPage, searchText, coreType],
    queryFn: async ({ pageParam = null }) => {
      const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberData`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Name: searchText || "",
          VillageName: Village || "",
          Address: Locality || "",
          IsMerged: IsMerged,
          CoreType: coreType,
          VoterID: pageParam || "",
          PerPage: rowsPerPage,
        }),
      });
      if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
      return await response.json();
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.HasNextPage) return undefined;
      const items = lastPage?.data || [];
      if (!items.length) return undefined;
      return items[items.length - 1]?.VoterID ?? undefined;
    },
    enabled,
  });
};

export const useYojanaMember = (enabled, Village, IsMerged, coreType = null) => {
  return useQuery({
    queryKey: ["Member-Data", Village, IsMerged],
    queryFn: () => fetchYojanaMemberData(Village, coreType),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useUserDetails = (enabled, UserID, UserName) => {
  return useQuery({
    queryKey: ["User-Details", UserID, UserName],
    queryFn: () => fetchUserDetails(UserID, UserName),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useYojanaSelect = (enabled) => {
  return useQuery({
    queryKey: ["Yojana-Select"],
    queryFn: () => fetchYojanaSelect(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useYojanaForDashboard = (enabled, Vidhansabha) => {
  return useQuery({
    queryKey: ["Yojana-For-Dashboard"],
    queryFn: () => fetchYojanaForDashboardData(Vidhansabha),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useGrantYojanaForDashboard = (enabled) => {
  return useQuery({
    queryKey: ["Grant-Yojana-For-Dashboard"],
    queryFn: () => fetchGrantYojanaForDashboardData(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useGrantVillageForDashboard = (enabled) => {
  return useQuery({
    queryKey: ["Grant-Village-For-Dashboard"],
    queryFn: () => fetchVillageYojanaForDashboardData(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useOverallDashboardCount = (enabled, Vidhansabha) => {
  return useQuery({
    queryKey: ["Overall-Dashboard-Count"],
    queryFn: () => fetchOverallDashboardCount(Vidhansabha),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useElectionResultDashboardData = (enabled) => {
  return useQuery({
    queryKey: ["Election-Result-Dashboard-Data"],
    queryFn: () => fetchElectionResultDashboard(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useGrantDashboardCount = (enabled) => {
  return useQuery({
    queryKey: ["Grant-Dashboard-Count"],
    queryFn: () => fetchGrantCount(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useYojanaWiseVillage = (enabled, GramYojnaID, Vidhansabha) => {
  return useQuery({
    queryKey: ["Yojana-Wise-Village", GramYojnaID, Vidhansabha],
    queryFn: () => fetchYojanaWiseVillage(GramYojnaID, Vidhansabha),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useGrantYojanaWiseVillage = (enabled, GrantYojnaName) => {
  return useQuery({
    queryKey: ["Grant-Yojana-Wise-Village", GrantYojnaName],
    queryFn: () => fetchGrantYojanaWiseVillage(GrantYojnaName),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useGrantVillageWiseYojana = (enabled, VillageID) => {
  return useQuery({
    queryKey: ["Grant-Village-Wise-Yojana", VillageID],
    queryFn: () => fetchGrantVillageWiseYojana(VillageID),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useBeneficialMemberData = (enabled, GramYojnaID, VillageEnglish) => {
  return useQuery({
    queryKey: ["Get-Beneficial-Member", GramYojnaID],
    queryFn: () => fetchBeneficialMember(GramYojnaID, VillageEnglish),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};
export const useVillageDashboard = (enabled) => {
  return useQuery({
    queryKey: ["Get-Village-Dashboard"],
    queryFn: () => fetchVillageDashboard(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useVillageWiseYojana = (enabled, VillageNameEnglish) => {
  return useQuery({
    queryKey: ["Village-Wise-Yojana", VillageNameEnglish],
    queryFn: () => fetchVillageWiseYojana(VillageNameEnglish),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useElectionResultCard = (enabled, electionLevel) => {
  return useQuery({
    queryKey: ["Election-Level-PDFs", electionLevel],
    queryFn: () => fetchingElectionLevelPdfs(electionLevel),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useIsMultipleElectionPDFs = (enabled, ElectionResultID) => {
  return useQuery({
    queryKey: ["ISMultiple-Election-Level-PDFs", ElectionResultID],
    queryFn: () => fetchingIsMultiplePdfs(ElectionResultID),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useBhajanMandaliTypeData = (enabled) => {
  return useQuery({
    queryKey: ["bhajan-mandali-type"],
    queryFn: () => fetchingBhajanMandaliType(),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useVillageWiseMandaliCountData = (enabled, BhajanMandaliTypeID) => {
  return useQuery({
    queryKey: ["villagewise-Mandali-count", BhajanMandaliTypeID],
    queryFn: () => fetchingVillageWiseMandaliCount(BhajanMandaliTypeID),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useVillageWiseMandaliDetailData = (enabled, vilageID, bhajanMandaliTypeID) => {
  return useQuery({
    queryKey: ["villagewise-Mandali-Detail-Data", vilageID, bhajanMandaliTypeID],
    queryFn: () => fetchingVillageWiseBhajanMandali(vilageID, bhajanMandaliTypeID),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useYojanaWiseMemberDetail = (enabled, FamilyHeadMasterID) => {
  return useQuery({
    queryKey: ["Yojana-Wise-Member-Detail", FamilyHeadMasterID],
    queryFn: () => fetchYojanaWiseMemberDetail(FamilyHeadMasterID),
    // staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled,
  });
};

export const useVidhanSabhaCountDetail = (enabled) => {
  return useQuery({
    queryKey: ["VidhanSabha-Count-Detail"],
    queryFn: () => fetchVidhanSabhaCountDetail(),
    staleTime: 0,
    retry: 1,
    enabled,
  });
};

//  *********************************************************************API CALLS*****************************************************

// const fetchVillage = async (IsAssignFamily) => {
//   try {
//     const response = await fetch(`${Narendra_Modi_Election_API_URL}getPartNameEnglishData`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         IsAssignFamily: IsAssignFamily,
//         IsActive: "true",
//         IsDelete: "false",
//       }),
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     return data?.data || [];
//   } catch (error) {
//     console.error("❌ Error fetching MainSite:", error);
//     return [];
//   }
// };
const fetchVillage = async (IsAssignFamily, coreType) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getPartNameEnglishData_V2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        IsAssignFamily: coreType === "Family" ? IsAssignFamily : null,
        PartNameEnglish: Cookies.get("Narendra_Modi_Village_ID") || "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchVillageMemberListFilter = async (IsAssignFamily, coreType, selectedVidhanSabha) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageNameEnglishData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        IsAssignFamily: coreType === "Family" ? IsAssignFamily : null,
        PartNameEnglish: Cookies.get("Narendra_Modi_Village_ID") || "",
        Vidhansabha: selectedVidhanSabha,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};
const fetchYojanaVillage = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageNameEnglishData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        IsAssignFamily: null,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchLocality = async (selectedVillage, IsAssignFamily, selectedVidhanSabha) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getLocalityData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        PartNameEnglish: selectedVillage,
        IsAssignFamily: IsAssignFamily,
        Vidhansabha: selectedVidhanSabha,
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchMemberData = async (Village, Locality, coreType) => {
  console.log("sdlfjsdlkfjsdkfjsdkfsdaf", coreType);
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        PartNameEnglish: Village,
        LocalityEnglish: Locality,
        IsAssignFamily: coreType == "Family" ? "false" : coreType == "Yojana" || coreType == "Yojana(Village)" ? "" : "false",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchYojanaMemberData = async (Village, coreType) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getMemberData_V2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        VillageNameEnglish: Village,
        IsAssignFamily: coreType == "Family" ? "false" : coreType == "Yojana" || coreType == "Yojana(Village)" ? "" : "false",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchUserDetails = async (UserUniqueID, LoginFrom) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getUserDetails_V1`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // UserID: UserID || "",
        // UserName: UserName || "",
        UserUniqueID: UserUniqueID || "",
        LoginFrom: LoginFrom || "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchYojanaSelect = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGramYojna`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        GramYojnaID: "",
        GramYojnaName: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchYojanaForDashboardData = async (Vidhansabha) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getYojnaForDashBoard`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        GramYojnaID: "",
        GramYojnaName: "",
        PerPage: "",
        UniqueID: "",
        Vidhansabha: Vidhansabha,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchGrantYojanaForDashboardData = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGrantYojna`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};
const fetchVillageYojanaForDashboardData = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGrantVillageList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchOverallDashboardCount = async (Vidhansabha) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getDashboardCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ Vidhansabha: Vidhansabha }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};
const fetchElectionResultDashboard = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getElectionResultType`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchGrantCount = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGrantYojnaDashboardCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchYojanaWiseVillage = async (GramYojnaID, Vidhansabha) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getYojnaWiseVillage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        GramYojnaID: GramYojnaID,
        Vidhansabha: Vidhansabha,
        GramYojnaName: "",
        PerPage: "",
        UniqueID: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchGrantYojanaWiseVillage = async (GrantYojnaName) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGrantYojnaWiseVillageList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        GrantYojnaName: GrantYojnaName,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};
const fetchGrantVillageWiseYojana = async (VillageID) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getGrantVillageWiseYojnaList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        VillageID: VillageID,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchBeneficialMember = async (GramYojnaID, VillageEnglish) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getBeneficialMemberData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        VillageNameEnglish: VillageEnglish || "",
        GramYojnaID: GramYojnaID || "",
        GramYojnaName: "",
        Name: "",
        BoothID: "",
        MobileNo: "",
        SLNo: "",
        IDCardNo: "",
        Gender: "",
        HouseNo: "",
        PerPage: "",
        UniqueID: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchVillageDashboard = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageDashboardCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        VillageNameEnglish: "",
        GramYojnaID: "",
        GramYojnaName: "",
        PerPage: "",
        UniqueID: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchVillageWiseYojana = async (VillageNameEnglish) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseYojna`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        VillageNameEnglish: VillageNameEnglish || "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchingElectionLevelPdfs = async (electionLevel) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getElectionResultData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ElectionResultID: "",
        ElectionLevel: electionLevel,
        Type: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};
const fetchingIsMultiplePdfs = async (ElectionResultID) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getElectionResultDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ElectionResultDetailID: "",
        ElectionResultID: ElectionResultID,
        ElectionType: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchingBhajanMandaliType = async () => {
  try {
    // const response = await fetch(`${Narendra_Modi_Election_API_URL}getBhajanMandaliType`, {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getBhajanMandaliType_V1`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        BhajanMandaliTypeID: "",
        BhajanMandaliType: "",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchingVillageWiseMandaliCount = async (BhajanMandaliTypeID) => {
  try {
    // const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliCount`, {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliCount_V1`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        BhajanMandaliTypeID: BhajanMandaliTypeID,
        BhajanMandaliType: "",
        VillageID: "",
        IsActive: "",
        IsDelete: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchingVillageWiseBhajanMandali = async (villageID, bhajanMandaliTypeID) => {
  try {
    // const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandaliCount`, {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseBhajanMandali`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        BhajanMandaliTypeID: bhajanMandaliTypeID || "",
        BhajanMandaliType: "",
        VillageID: villageID || "",
        IsActive: "",
        IsDelete: "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchYojanaWiseMemberDetail = async (FamilyHeadMasterID) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getYojnaDataWithMembersData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        FamilyHeadMasterID: FamilyHeadMasterID || "",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

const fetchVidhanSabhaCountDetail = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVishansabhaDashboardCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching MainSite:", error);
    return [];
  }
};

// -------------------khushi---------------------------
export const useVillageWiseSakhiMandalCount = (enabled, type = "SakhiMandal") => {
  return useQuery({
    queryKey: ["villagewise-Sakhi-Mandal-count", type],
    queryFn: () => fetchingVillageWiseSakhiMandalCount(type),
    enabled: enabled,
  });
};

const fetchingVillageWiseSakhiMandalCount = async (type) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseSakhiMandalCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        SakhiMandalName: "",
        Type: type,
        Village: "",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching VillageWiseSakhiMandalCount:", error);
    return [];
  }
};

export const useVillageWiseSakhiMandalDetail = (enabled, villageName, type = "SakhiMandal") => {
  return useQuery({
    queryKey: ["villagewise-Sakhi-Mandal-detail", villageName, type],
    queryFn: () => fetchingVillageWiseSakhiMandalDetail(villageName, type),
    enabled: enabled && !!villageName,
  });
};

const fetchingVillageWiseSakhiMandalDetail = async (villageName, type) => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getVillageWiseSakhiMandal`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        SHGMemberID: "",
        Type: type,
        SHGCode: "",
        SakhiMandalName: "",
        MemberCode: "",
        MemberName: "",
        Village: villageName || "",
        GramPanchayat: "",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching VillageWiseSakhiMandalDetail:", error);
    return [];
  }
};

export const useSakhiMandalWiseMemberDetailDataPagination = (enabled, rowsPerPage, sakhiMandalName, villageName, filterData = {}, type = "SakhiMandal") =>
  useInfiniteQuery({
    queryKey: ["SakhiMandalDetailData", rowsPerPage, sakhiMandalName, villageName, type, filterData],
    enabled: enabled,
    queryFn: async ({ pageParam = null }) => {
      const selectedGramPanchayat = villageName || "";
      const filteredGramPanchayat = filterData?.gramPanchayat || "";
      const shgName = filterData?.shgName || filterData?.sakhiMandalName || sakhiMandalName || "";
      const usesDashboardFilters = ["Anganwadi", "Harpati", "YuvaSanghatan"].includes(type);
      const temptItems = {
        SHGMemberID: "",
        Type: type,
        SHGCode: filterData?.shgCode || "",
        SHGName: shgName,
        SakhiMandalName: shgName,
        MemberCode: filterData?.memberCode || "",
        MemberName: filterData?.studentName || filterData?.memberName || "",
        MobileNo: filterData?.mobileNo || "",
        StudentID: filterData?.studentID || "",
        StudentName: filterData?.studentName || filterData?.memberName || "",
        StudentCaste: filterData?.studentCaste || "",
        Year: filterData?.year || "",
        Village: selectedGramPanchayat,
        GramPanchayat: filteredGramPanchayat,
        AWC: filterData?.awc || "",
        DesignationInSHG: filterData?.designationInSHG || "",
        IsActive: "true",
        IsDelete: "false",
        PerPage: rowsPerPage,
        UniqueID: pageParam,
      };

      if (usesDashboardFilters) {
        const allItems = [];
        let uniqueID = null;
        let hasMore = true;

        while (hasMore) {
          const allDataPayload = {
            ...temptItems,
            SHGName: "",
            SakhiMandalName: "",
            MemberName: "",
            MobileNo: "",
            StudentName: "",
            DesignationInSHG: "",
            PerPage: "",
            UniqueID: uniqueID,
          };
          const allDataResponse = await fetch(`${Narendra_Modi_Election_API_URL}getSakhiMandalWiseMemberDetail`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(allDataPayload),
          });
          if (!allDataResponse.ok) throw new Error(`Network response was not ok: ${allDataResponse.statusText}`);

          const result = await allDataResponse.json();
          const batch = result?.data || [];
          allItems.push(...batch);
          hasMore = Boolean(result?.HasNextPage && batch.length);
          uniqueID = hasMore ? batch[batch.length - 1]?.SHGMemberID : null;
        }

        const contains = (value, search) =>
          !search ||
          String(value || "")
            .toLowerCase()
            .includes(String(search).trim().toLowerCase());
        const filteredItems = allItems.filter(
          (item) =>
            contains(item?.GramPanchayat, filteredGramPanchayat) &&
            contains(item?.AWC, filterData?.awc) &&
            contains(item?.SHGName, filterData?.shgName) &&
            contains(item?.MemberName, filterData?.memberName) &&
            contains(item?.DesignationInSHG, filterData?.designationInSHG) &&
            contains(item?.MobileNo, filterData?.mobileNo),
        );
        const pageIndex = Number(pageParam) || 0;
        const startIndex = pageIndex * rowsPerPage;
        const data = filteredItems.slice(startIndex, startIndex + rowsPerPage);

        return {
          data,
          TotalCount: filteredItems.length,
          HasNextPage: startIndex + rowsPerPage < filteredItems.length,
          NextPageParam: pageIndex + 1,
        };
      }

      const response = await fetch(`${Narendra_Modi_Election_API_URL}getSakhiMandalWiseMemberDetail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(temptItems),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      return lastPage?.HasNextPage ? (lastPage?.NextPageParam ?? lastPage?.data?.[lastPage?.data?.length - 1]?.SHGMemberID) : undefined;
    },
  });

export const useOverallSummaryCountNew = (enabled) => {
  return useQuery({
    queryKey: ["Overall-Summary-Count-New"],
    queryFn: () => fetchOverallSummaryCountNew(),
    retry: 1,
    enabled,
  });
};

const fetchOverallSummaryCountNew = async () => {
  try {
    const response = await fetch(`${Narendra_Modi_Election_API_URL}getOverallSummaryCount`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Type: "SakhiMandal",
        IsActive: "true",
        IsDelete: "false",
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || [];
  } catch (error) {
    console.error("❌ Error fetching Overall Summary:", error);
    return [];
  }
};
